<template>
  <div>

    <b-container fluid class="header noselect">
      <b-row>
        <!-- Menu -->
        <b-col cols="2" class="d-lg-none text-left" align-self="center">
          <p class="logout m-0" @click="showMenu = !showMenu">
            <icon scale="1" name="bars"></icon>
          </p>
        </b-col>
        <!-- Logo -->
        <b-col cols="8" lg="2">
          <img class="p-2 mb-1 rounded-bottom logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
        <!-- Sair Mobile -->
        <b-col cols="2" align-self="center" class="py-1 d-lg-none text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>


        <b-col cols="12" lg="8" align-self="center" class="my-2">
          <b-row class="text-center">
            <!-- <b-col cols="12">
              <b-badge variant="dark">
                {{ $gui.event }}
              </b-badge>
            </b-col> -->
            <b-col cols="12">
              <h1 class="title m-0">
                {{ event.name }}
              </h1>
            </b-col>
          </b-row>
        </b-col>

        <!-- Sair Desktop -->
        <b-col lg="2" align-self="center" class="py-1 d-none d-lg-block text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>

      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="2" v-if="showMenu" class="mmenu noselect pt-4">

          <h1>Página Inicial</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'OrganizerEvents' }" v-if="isOrganizer">
              <icon scale="0.9" class="mr-1" name="arrow-left"></icon> Voltar
            </b-nav-item>
            <b-nav-item :to="{ name: backRoute }" v-if="isAdmin">
              <icon scale="0.9" class="mr-1" name="arrow-left"></icon> Voltar
            </b-nav-item>
          </b-nav>

          <h1>Catálogo</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item v-if="event.categories_enabled === 1" :to="{ name: 'OrganizerCategories' }">
              <icon scale="0.9" class="mr-1" name="tags"></icon> Categorias
            </b-nav-item>
            <b-nav-item :to="{ name: 'OrganizerBatches' }">
              <icon scale="0.9" class="mr-1" name="book"></icon> {{ this.$gui.batches }}
            </b-nav-item>
            <b-nav-item :to="{ name: 'OrganizerDealers' }">
              <icon scale="0.9" class="mr-1" name="users"></icon> {{ this.$gui.dealers }}
            </b-nav-item>
          </b-nav>

          <h1>{{ this.$gui.tickets }}</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'OrganizerCreateTickets' }">
              <icon scale="0.9" class="mr-1" name="print"></icon> Imprimir {{ this.$gui.tickets }}
            </b-nav-item>
            <b-nav-item :to="{ name: 'OrganizerListTickets' }">
              <icon scale="0.9" class="mr-1" name="ticket-alt"></icon> Listar {{ this.$gui.tickets }}
            </b-nav-item>
          </b-nav>

          <div v-if="event.virtual_store === 1">
            <h1>Loja Virtual</h1>
            <b-nav vertical class="mb-4 mt-1 rounded">
              <b-nav-item :to="{ name: 'OrganizerCreateStore' }">
                <icon scale="0.9" class="mr-1" name="shopping-bag"></icon> Loja virtual
              </b-nav-item>
              <b-nav-item v-if="event.has_online_dealer" :to="{ name: 'OrganizerOrdersList' }">
                <icon scale="0.9" class="mr-1" name="shopping-cart"></icon> Pedidos
              </b-nav-item>
              <b-nav-item v-if="event.coupon_discount_enabled === 1" :to="{ name: 'Coupons' }">
                <icon scale="0.9" class="mr-1" name="ticket-alt"></icon> Cupons de Desconto
              </b-nav-item>
            </b-nav>
          </div>

          <h1>Relatórios</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'OrganizerPrintReport' }">
              <icon scale="0.9" class="mr-1" name="table"></icon> {{ this.$gui.printReport }}
            </b-nav-item>
            <b-nav-item :to="{ name: 'OrganizerTimeReport' }" v-if="this.$gui.isEvento">
              <icon scale="0.9" class="mr-1" name="users"></icon> Público Presente
            </b-nav-item>
                <b-nav-item :to="{ name: 'OrganizerTicketTransfer' }" v-if="this.$gui.isEvento">
                  <icon scale="0.9" class="mr-1" name="exchange-alt"></icon> Alteração de Titularidade
                </b-nav-item>
              </b-nav>

              <h1>Aplicativo</h1>
              <b-nav vertical class="mb-4 mt-1 rounded">
                <b-nav-item :to="{ name: 'OrganizerApp' }">
                  <icon scale="0.9" class="mr-1" name="download"></icon> Instalar Aplicativo
                </b-nav-item>
                <b-nav-item :to="{ name: 'OrganizerAppPrint' }">
                  <icon scale="0.9" class="mr-1" name="print"></icon> Ativar Impressão
                </b-nav-item>
                <b-nav-item :to="{ name: 'OrganizerAppValidate' }" v-if="this.$gui.isEvento">
              <icon scale="0.9" class="mr-1" name="video"></icon> Ativar Validação
            </b-nav-item>
          </b-nav>

          <h1>Suporte</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item href="https://api.whatsapp.com/send?phone=5535998351273&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20sobre%20a%20Easytick." target="_blank">
              <icon scale="0.9" class="mr-1" name="comments"></icon> WhatsApp Gabriel
            </b-nav-item>
            <b-nav-item href="https://api.whatsapp.com/send?phone=5535998700887&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20sobre%20a%20Easytick." target="_blank">
              <icon scale="0.9" class="mr-1" name="comments"></icon> WhatsApp Gilson
            </b-nav-item>
          </b-nav>
        </b-col>

        <b-col cols="12" lg="10" style="min-height: calc(100vh - 95.17px)" class="pt-3">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="footer">
      <b-row>
        <b-col>
          <p class="text-center my-2"><strong>Easytick</strong>, desde 2017 🎉</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import Ticket from './../Ticket'
import OrganizerNewDealer from './OrganizerNewDealer'
import OrganizerDealers from './OrganizerDealers'
import OrganizerCreateTickets from './OrganizerCreateTickets'
import OrganizerBatches from './OrganizerBatches'
import Gui from '@/gui'

export default {
  name: 'OrganizerDashboard',
  components: {
    'ticket': Ticket,
    'new-dealer': OrganizerNewDealer,
    'dealers': OrganizerDealers,
    'tickets': OrganizerCreateTickets,
    'batches': OrganizerBatches
  },
  data () {
    return {
      loginError: false,
      organizer: null,
      role: '',
      event: {},
      showMenu: true,
      backRoute: 'Events'
    }
  },
  beforeCreate () {
    let type = this.$session.get('type')
    let gui = new Gui(type)
    Object.defineProperty(Vue.prototype, '$gui', {value: gui, configurable: true})
  },
  created () {
    this.role = this.$session.get('role')
    this.organizer = this.$route.params.organizer
    this.backRoute = this.$session.get('organizerBackRoute') || 'Events'

    this.getEvent().then(resp => {
      this.event = resp.body
      // Preload logo
      let image = new Image()
      image.src = resp.body.image
    })
  },
  methods: {
    getEvent () {
      return this.$http.get(process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events')
    },
    getEventAndOpen () {
      this.getEvent().then(() => {
        this.open()
      })
    },
    open (ticketsNumbers) {
      let route = this.$router.resolve({
        name: 'OrganizerRenderTickets',
        params: {organizer: this.organizer},
        query: {n: ticketsNumbers}
      })
      window.open(route.href, '_blank')
    },
    appendNewDealer (newDealer) {
      this.event.dealers.push(newDealer)
    },
    appendNewBatch (newBatch) {
      this.event.batches.push(newBatch)
    },
    showTickets (ticketsNumbers) {
      this.open(ticketsNumbers)
    },
    removeDealer (dealerId) {
      this.event.dealers = this.$_.filter(this.event.dealers, d => {
        return d.id !== dealerId
      })
    },
    removeToken (dealerId) {
      let index = this.$_.findIndex(this.event.dealers, d => {
        return d.id === dealerId
      })
      this.event.dealers[index].token = null
    },
    appendToken (obj) {
      let index = this.$_.findIndex(this.event.dealers, d => {
        return d.id === obj.dealerId
      })
      this.event.dealers[index].token = obj.token
    }
  },
  computed: {
    isOrganizer () {
      return this.role === 'organizer'
    },
    isAdmin () {
      return this.role === 'admin'
    }
  }
}
</script>
